import { Typography } from 'antd'
import React from 'react'

interface HighlightProps {
  text: string
}

export const Highlight: React.FC<HighlightProps> = React.memo(({ text }): any => {
  return text
    .split(/<highlight>(.+?)<\/highlight>/g)
    .map((s, i) =>
      i % 2 == 0 ? (
        s
      ) : (
        <Typography.Text key={i} style={{ color: '#C43131', fontWeight: 500 }}>
          {s}
        </Typography.Text>
      )
    )
    .filter(Boolean)
})
